<template>
    <div class="StepBar">
        <BaseButton :to="'/'+$route.fullPath.split('/')[1]" outlined v-if="current === 0">Zpět</BaseButton>
        <BaseButton @click="$emit('stepChange', current - 1)" outlined v-else>Zpět</BaseButton>
        <BaseButton @click="reset" muted><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="redo-alt" class="svg-inline--fa fa-redo-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"></path></svg></BaseButton>
        <div class="StepBar-total">
            <span>Celkem:</span>
            <template v-if="total.totalPrice">{{ formatPrice(total.totalPrice) }}</template>
            <template v-else>0 Kč</template>
        </div>
        <BaseButton @click="$emit('stepChange', current + 1)" :class="{'is-disabled': !settings[current].valid || (current === settings.length - 2 && total.totalPrice < total.minimumFinalPrice)}" v-if="current !== settings.length - 1">Pokračovat</BaseButton>
    </div>
</template>

<script>
import {formatPrice} from "../utils/utils";

export default {
    name: 'StepBar',
    props: {
        current: Number,
        settings: Array,
        total: Object
    },
    setup() {
        const reload = () => {
            location.reload();
        }
        const reset = () => {
            if (confirm("Opravdu si přejete konfiguraci vymazat a začít znova?"))
                window.location = "/";
        }
        return {
            reload,
            reset,
            formatPrice
        }
    }
}
</script>

<style lang="scss" scoped>
.StepBar {
    display: flex;
    align-items: center;
    gap: .4em;
    margin-top: 2em;

    @media(max-width: 980px) {
        padding: .5em 1em;
        background: #fff;
        margin-top: 0;
        box-shadow: 0 0 20px #00000036;
    }

    &-total {
        flex: 1;
        text-align: right;
        padding: 0 1em;
        font-size: 1.1em;
        display: none;
        font-weight: 700;
        line-height: 1.1;
        margin-top: -.2em;

        @media(max-width: 980px) {
            display: block;
        }

        span {
            font-weight: 400;
            font-size: .8em;
            display: block;
        }
    }

    a, button {
        &:last-child {
            margin-left: auto;
        }

        @media(max-width: 980px) {
            font-size: .75em;
        }
    }
}
</style>